import { useState } from "react";
export default function Form(props) {
  const [desc, setDec] = useState("");
  const [quantity, setQuantity] = useState(1);

  function handleInput(e) {
    setDec(e.target.value);
  }
  function handelSelect(e) {
    setQuantity(Number(e.target.value));
  }

  function handleSubmit(e) {
    e.preventDefault();

    if (!desc) return;

    const newDate = { desc, quantity, picked: false, id: Date.now() };

    props.setData((prev) => {
      return [...prev, newDate];
    });
    setDec("");
    setQuantity(1);
  }
  return (
    <form
      className="bg-orange-400  h-14 w-full flex space-x-4 justify-center items-center"
      onSubmit={handleSubmit}
    >
      <h3>What do yo need for your 😍 tripe</h3>
      <select
        className="rounded-xl focus:outline-0 "
        onChange={handelSelect}
        value={quantity}
      >
        {Array.from({ length: 20 }, (_, i) => i + 1).map((i) => (
          <option
            value={i}
            key={i}
            className="bg-yellow-700 text-white text-xs"
          >
            {i}
          </option>
        ))}
      </select>
      <input
        type="text"
        placeholder="items..."
        className="rounded-xl outline-0 pl-4"
        onChange={handleInput}
        value={desc}
      />
      <button className="px-2 py-1 rounded-xl bg-green-300 hover:bg-green-400 active:translate-y-[2px] select-none">
        Add
      </button>
    </form>
  );
}
